import { useState, useEffect } from 'react';

import { useLocalStorage } from 'src/hooks/use-local-storage';

import { useAuthContext } from 'src/auth/hooks';

function GoogleAnalytics() {
  const [initiated, setInitiated] = useState(false);

  const { state, setState } = useLocalStorage('cookie-request', {
    accepted: false,
    timestamp: new Date().toISOString(),
    userMadeAction: false,
  });

  const auth = useAuthContext();

  useEffect(() => {
    // if user is accepted analytics consent via auth, set usermadeaction so popup will not show
    /*      const madeActionViaAuth = state.userMadeAction || state.accepted;

      setState({
        accepted: auth.user.analyticsConsent,
        timestamp: new Date().toISOString(),
        userMadeAction: madeActionViaAuth,
      }); */

    if (!initiated) {
      window.dataLayer = window.dataLayer || [];
    }

    setInitiated(true);
  }, [
    auth.loading,
    auth.authenticated,
    auth.user,
    setState,
    state.accepted,
    state.userMadeAction,
    initiated,
  ]);

  return null;
}

export default GoogleAnalytics;
